import { h, JSX, FunctionalComponent } from "preact";
import { Icon } from "@uw/icons/types";
const defaultStyle = {
  width: "24px",
  height: "24px",
  display: "flex",
};
const SvgIcon = (props: JSX.SVGAttributes<any>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 17" {...props}>
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M154 16H21.243a3 3 0 0 1-2.122-.879l-14-14A3 3 0 0 0 0 3.243V48c0 6.627 5.373 12 12 12h142c6.627 0 12-5.373 12-12V28c0-6.627-5.373-12-12-12Z"
    />
  </svg>
);
export const TooltipTailLeftIcon: FunctionalComponent<Icon> = ({
  className,
  svgAttrs = {
    width: "100%",
    height: "100%",
  },
  key,
  jsx,
  children,
  ref,
  ...styles
}) => (
  <span
    className={className}
    style={{
      ...defaultStyle,
      ...styles,
    }}
  >
    <SvgIcon {...svgAttrs} />
  </span>
);
